import { render, staticRenderFns } from "./Recorder.vue?vue&type=template&id=5def79e0&scoped=true"
import script from "./Recorder.vue?vue&type=script&lang=js"
export * from "./Recorder.vue?vue&type=script&lang=js"
import style0 from "./Recorder.vue?vue&type=style&index=0&id=5def79e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def79e0",
  null
  
)

export default component.exports